import { Stack } from '@fluentui/react';
import { DocumentList } from 'common/components/DocumentList';
import React from 'react';
import { Invoice_invoice_entityDocumentsByEntityId } from '../../../__generated__/Invoice';
import { useStyles } from './index.styles';
import { NoDataView } from 'common/components/DataPlaceholders';
import { getWindowDimensions } from 'common/utils/columnUtilities';
import { columns } from 'common/components/ActionMenu/column.data';

interface FileSectionProps {
  fileListData: Invoice_invoice_entityDocumentsByEntityId;
}
export const FilesSection: React.FC<FileSectionProps> = ({ fileListData }) => {
  const styles = useStyles();

  const { width } = getWindowDimensions();
  const documentViewPosition = width ? width * 0.8 - 500 : 50;

  return (
    <Stack tokens={{ childrenGap: 10 }} className={styles.mainStack}>
      <Stack tokens={{ childrenGap: 10, padding: 10 }}>
        {fileListData.nodes.length && (
          <DocumentList
            isNew={false}
            columns={columns}
            data={fileListData.nodes || []}
            paddingLeft={documentViewPosition}
          />
        )}
        <NoDataView
          show={fileListData.nodes.length === 0}
          title="No Attachments"
        />
      </Stack>
    </Stack>
  );
};
